import { getProductType as getProductTypeFromDraft } from '@/model/draft/getProductType';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { StoreState } from '@/redux/types';

export const getProductType = (state: StoreState) => getProductTypeFromDraft(getDraft(state));
